import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Prop} from 'vue-property-decorator';
import { Status } from '@/models/status.model';
import ToolsService from '@/providers/tools';
import BoardPage from '@/homework/models/board-page.model';

@Component({
  name: 'ed-pdf-viewer'
})
export default class EdPdfViewer extends Vue { 
  
  /* Props */
  @Prop() readonly url: string;
  @Prop({default: null}) readonly initNumberPage: number;
  @Prop({default: false, required: false}) isPresentationFile : boolean;
  @Prop({default: 'pdf-viewer', required: false}) readonly viewerIdPrefix : number;
  @Prop() readonly documentHash : string;
  @Prop() documentIndex : number;
  @Prop() courseId : number;
  @Prop() name: string;
  @Prop({default: false, required: false}) readonly allowExtraPages: boolean;
  
  
  /* Data */
  public isFileInCache = false;
  public loadingProgress: number = 0;
  public downloadProgress: number = 0;
  public downloadTotalSize: number = 0;
  public downloadSpeed: number = 0;
  public urlPDF: string = '';
  public status: Status = new Status();
  public loaderClass = { 'loader-hidden': false };
  public pdfJs: any = null;

  get hash(): string {
    const url = this.url.substring(this.url.lastIndexOf('/') + 1);
    return url.split('#')[0];
  }

  get idRender(): string {
    const pdfJs: any = this.$refs.PDFJS;
    return pdfJs.idRender;
  }
  
  hideLoader() {
    if(this.isFileInCache) {
      this.loadingProgress = 100;
      this.loaderClass['loader-hidden'] = true;
      setTimeout(() => {
        this.status.setLoad();
      }, 500);
    } else {
      this.loadingProgress = 90;
      setTimeout(() => {
        this.loadingProgress = 100;
        this.loaderClass['loader-hidden'] = true;
        setTimeout(() => {
          this.status.setLoad();
        }, 500);
      }, 500);
    }
  }

  getFile(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const bytesInMb = 1000000;
      // PDF.js downloads the original file itself, so it must include the Media cookie.
      const documentPDF = pdfjsLib.getDocument({ url, withCredentials: true });
      const downloadingStartTime = (new Date()).getTime();

      documentPDF.onProgress = (res) => {
        const downloadingEndTime = (new Date()).getTime();
        this.displaySpeed(downloadingStartTime, downloadingEndTime, res.loaded)
        if(this.downloadTotalSize === 0) {
          this.downloadTotalSize = res.total / bytesInMb;
        }
        
        const value = Math.floor((res.loaded/res.total) * 80);
        if(value < 80 && value >= this.loadingProgress) {
          this.loadingProgress = value;
          this.downloadProgress = res.loaded / bytesInMb;
        }
      }

      documentPDF.promise.then(async (pdf: any) => {
        pdf.getData()
            .then(async data => {
              const blob = new Blob([data], {type: 'application/pdf'});
              const urlPdf = URL.createObjectURL(blob);
              await this.$FilesCache.cacheFile(this.hash, data);
              resolve(urlPdf);
            })
            .then(async (pdf: any) => {
              documentPDF.destroy();
            });
      })
    });
  }

  displaySpeed(downloadingStartTime, downloadingEndTime, downloadProgress) {
    let timeDuration = (downloadingEndTime - downloadingStartTime) / 1000;

    let bps = (downloadProgress) / timeDuration;
    let kbps = bps / 1024;
    let mbps = kbps / 1024;

    function round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    }

    this.downloadSpeed = round(mbps, 1);
}

  async getUrlFile() {
    let url = await this.$FilesCache.getUrlFile(this.hash);
    if(url) {
      this.isFileInCache = true;
    } else {
      url = await this.getFile(this.url);
    }
    return url;
  }

  async initPDF() {
    this.status.setLoading();
    await ToolsService.sleep(100);
    this.pdfJs = this.$refs.PDFJS;
    this.urlPDF = await this.getUrlFile();
    await ToolsService.sleep(100);
    this.loadingProgress = 90;
    await this.pdfJs?.renderPdf();
    this.hideLoader();
  }



  @Emit('loadingPage')
  public loadingPage(pageData: {isTransparency?: boolean, height: number, width: number, page: number, docKey: string}) {
    // Let the @Emit decorator just emit the passed data
  }

  @Emit('onChangeSelectedPage')
  public onChangeSelectedPage(page: number) {
    // Let the @Emit decorator just emit the passed data

  }

  @Emit('onInitRender')
  public onInitRender(pageSizes: {id: number, width: number, height: number }[]): void {
    // Let the @Emit decorator just emit the passed data
  }

  /* Hooks */
  mounted() {
    this.initPDF();
  }

}
